import * as React from 'react';
import { Button, Card, CardActions, CardContent, CircularProgress, Dialog, IconButton, Link, ListItemIcon, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@material-ui/core';
import { _PortalState } from '../../helpers/state';
import { PhaseItemForm } from './PhaseItemForm';
import { Add, CheckBox, CheckBoxOutlineBlank, Clear, RateReview, MoreVert, More, MoreHoriz, Edit, QuestionAnswer, Done, EmojiEvents } from '@material-ui/icons';
import { QueryClient, useQuery } from 'react-query';
import * as microsoftTeams from "@microsoft/teams-js";
import Loading from '../Loading';
import { InterviewsForm } from './InterviewsForm';
import { ValidationForm } from './ValidationForm';
import { PhaseValidationForm } from './PhaseValidationForm';
import './phase.css'

const queryClient = new QueryClient();

export const Phase: React.FC<PhaseProps> = (props: PhaseProps) => {

    const [DialogOpen, setDialogOpen] = React.useState<boolean>(false);
    const [DialogInterviewOpen, setDialogInterviewOpen] = React.useState<boolean>(false);
    const [DialogValidationOpen, setDialogValidationOpen] = React.useState<boolean>(false);
    const [DialogPhaseValidationOpen, setDialogPhaseValidationOpen] = React.useState<boolean>(false);
    const [experimentId, setExperimentId] = React.useState<string>();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClose = () => {
        setAnchorEl(null);
    };


    const { isLoading, isError, data, error, refetch } = useQuery<any>(['phase', props.phase.Id], async () => {
        return new Promise<any>(async (resolve, reject) => {
            // console.log('fetch phase ' + props.phase.Id);
            microsoftTeams.initialize(() => {
                microsoftTeams.authentication.getAuthToken({
                    successCallback: (token: string) => {
                        // console.log(token);
                        fetch(_PortalState.ApiEndpoint + "/experiment?phaseid=" + props.phase.Id + "&groupid=" + _PortalState.teamsContext.groupId,
                            {
                                method: 'GET',
                                headers:
                                    { "Authorization": "bearer " + token }
                            })
                            .then(res => res.json())
                            .then((experiments: any[]) => {
                                // console.log(res);

                                fetch(_PortalState.ApiEndpoint + "/phasevalidation?phaseid=" + props.phase.Id + '&groupid=' + _PortalState.teamsContext.groupId,
                                    {
                                        method: 'GET',
                                        headers:
                                            { "Authorization": "bearer " + token }
                                    })
                                    .then(res => res.json())
                                    .then((validation: any[]) => {
                                        // if (props.phase.Id === 'b80ace52-8948-4d90-8cae-15ec09754e77')
                                        resolve({
                                            experiments: experiments,
                                            validation: validation.length === 1 ? validation[0] : undefined
                                        });
                                    });

                            });
                    }
                })
            });
        })
    }, {});

    return (
        <>
            <Dialog
                // fullWidth={true}
                // maxWidth="md"
                fullScreen
                open={DialogOpen}
                ria-labelledby="form-dialog-title"
            >
                <PhaseItemForm
                    experimentId={experimentId}
                    phase={props.phase}
                    onClose={() => setDialogOpen(false)}
                    onSave={(designData) => {
                        // console.log(data);
                        setDialogOpen(false);
                        console.log('saving', designData);
                        microsoftTeams.authentication.getAuthToken({
                            successCallback: (token: string) => {
                                if (experimentId && data && data.experiments) {
                                    let experiment: any = data.experiments.filter((e: any) => e.experimentId === designData.experimentId)[0];
                                    console.log(experiment);
                                    Object.keys(designData.data).map(d => {
                                        experiment.data[d] = designData.data[d];
                                    })
                                    fetch(_PortalState.ApiEndpoint + "/experiment",
                                        {
                                            method: 'PATCH',
                                            headers:
                                                { "Authorization": "bearer " + token },
                                            body: JSON.stringify(experiment)
                                        })
                                        .then((res: any) => {
                                            // console.log(res);
                                        })
                                        .finally(() => {
                                            refetch();
                                        })
                                }
                                else
                                    fetch(_PortalState.ApiEndpoint + "/experiment",
                                        {
                                            method: 'POST',
                                            headers:
                                                { "Authorization": "bearer " + token },
                                            body: JSON.stringify(designData)
                                        })
                                        .then((res: any) => {
                                            // console.log(res);
                                        })
                                        .finally(() => {
                                            refetch();
                                        })

                            }
                        })
                    }
                    }
                />
            </Dialog>
            <Dialog
                fullScreen
                open={DialogInterviewOpen}
                ria-labelledby="form-dialog-title"
            >
                <InterviewsForm
                    // phaseTitle={"Problem discovery"}
                    // phaseId={0}
                    experimentId={experimentId ? experimentId : ''}
                    phase={props.phase}
                    onClose={() => { setDialogInterviewOpen(false); refetch() }}
                />
            </Dialog>
            <Dialog
                fullScreen
                open={DialogValidationOpen}
                ria-labelledby="form-dialog-title"
            >
                <ValidationForm
                    experimentId={experimentId}
                    phase={props.phase}
                    onClose={() => setDialogValidationOpen(false)}
                    onSave={(validationData) => {
                        setDialogValidationOpen(false);
                        console.log('saving', validationData);
                        microsoftTeams.authentication.getAuthToken({
                            successCallback: (token: string) => {
                                // get this particular experiment
                                if (data) {
                                    console.log(data);
                                    let experiment: any = data.experiments.filter((e: any) => e.experimentId === validationData.experimentId)[0];
                                    console.log(experiment);
                                    Object.keys(validationData.data).map(d => {
                                        experiment.data[d] = validationData.data[d];
                                    })
                                    fetch(_PortalState.ApiEndpoint + "/experiment",
                                        {
                                            method: 'PATCH',
                                            headers:
                                                { "Authorization": "bearer " + token },
                                            body: JSON.stringify(experiment)
                                        })
                                        .then((res: any) => {
                                            console.log(res);
                                        })
                                        .finally(() => {
                                            refetch();
                                        })
                                }
                            }
                        })
                    }
                    }
                />
            </Dialog>
            <Dialog
                fullScreen
                open={DialogPhaseValidationOpen}
                ria-labelledby="form-dialog-title"
            >
                <PhaseValidationForm
                    phase={props.phase}
                    onClose={() => setDialogPhaseValidationOpen(false)}
                    onSave={(validationData) => {
                        setDialogPhaseValidationOpen(false);
                        console.log('saving', validationData);
                        microsoftTeams.authentication.getAuthToken({
                            successCallback: (token: string) => {
                                // get this particular experiment
                                if (data) {
                                    fetch(_PortalState.ApiEndpoint + "/phasevalidation",
                                        {
                                            method: 'PATCH',
                                            headers:
                                                { "Authorization": "bearer " + token },
                                            body: JSON.stringify(validationData)
                                        })
                                        .then((res: any) => {
                                            console.log(res);
                                        })
                                        .finally(() => {
                                            refetch();
                                        })
                                }
                            }
                        })
                    }
                    }
                />
            </Dialog>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}>Design</MenuItem>
                <MenuItem onClick={handleClose}>Interviews</MenuItem>
                <MenuItem onClick={handleClose}>Validation</MenuItem>
            </Menu>
            <Card >
                <CardContent className={data && data.validation && data.validation?.data?.validated ? "phase-done" : "phase-not-done"}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        {props.phase.Name}
                        {data && data.validation && data.validation?.data?.validated === "Validate" &&
                            <span> (validated)</span>
                        }
                        {data && data.validation && data.validation?.data?.validated === "Invalidate" &&
                            <span> (invalidated)</span>
                        }
                        {data && data.validation && data.validation?.data?.validated === "Inconclusive" &&
                            <span> (inconclusive)</span>
                        }
                    </Typography>
                    {isLoading &&
                        <div style={{ width: '250px', margin: 'auto', height: '250px', textAlign: 'center' }}>
                            <CircularProgress />
                        </div>
                    }
                    {!isLoading && data &&
                        // <br />
                        <TableContainer style={{ height: '300px' }} >
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell align="right"># interviews</TableCell>
                                        <TableCell align="right">Status</TableCell>
                                        <TableCell width='10px' align="right"></TableCell>
                                        <TableCell width='10px' align="right"></TableCell>
                                        <TableCell width='10px' align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.experiments ? data.experiments.map((row: any) => (
                                        <TableRow key={row.id}>
                                            <TableCell component="th" scope="row">
                                                {/* <Link style={{ cursor: 'pointer' }} */}

                                                {/* onClick={() => { setExperimentId(row.experimentId); setDialogOpen(true); }}
                                                > */}
                                                {row.data.name}
                                                {/* </Link> */}
                                            </TableCell>
                                            <TableCell align="right">
                                                {/* <Button onClick={() => { setExperimentId(row.experimentId); setDialogInterviewOpen(true); }} variant="contained" color={row.numberInterviews === 0 ? "secondary" : "primary"}> */}
                                                {row.numberInterviews}
                                                {/* </Button> */}
                                            </TableCell>
                                            <TableCell align="right">
                                                <ListItemIcon>
                                                    {/* <Link style={{ cursor: 'pointer', position: 'absolute', marginTop: '-16px' }} onClick={() => { setExperimentId(row.experimentId); setDialogValidationOpen(true); }}> */}
                                                    {/* {(!row.data || !row.data.validated) &&
                                                        <ListItemIcon>
                                                            <CheckBoxOutlineBlank />
                                                        </ListItemIcon>
                                                    } */}
                                                    {row.data.validated && row.data.validated === "Inconclusive" &&
                                                        <span>
                                                            Inconclusive
                                                        </span>
                                                        // <ListItemIcon>
                                                        //     <CheckBoxOutlineBlank />
                                                        // </ListItemIcon>
                                                    }
                                                    {row.data.validated && row.data.validated === "Invalidate" &&
                                                        <span>
                                                            Invalidated
                                                        </span>
                                                        // <ListItemIcon style={{ color: '#f50057' }}>
                                                        //     <Clear />
                                                        // </ListItemIcon>
                                                    }
                                                    {row.data.validated && row.data.validated === "Validate" &&
                                                        <span>
                                                            Validated
                                                        </span>
                                                        // <ListItemIcon style={{ color: '#3f51b5' }}>
                                                        //     <CheckBox />
                                                        // </ListItemIcon>
                                                    }
                                                    {/* </Link> */}
                                                    {/* {row.Validated === 0 &&
                                                    <CheckBoxOutlineBlank />
                                                }
                                                {row.Validated === 1 &&
                                                    <CheckBox />
                                                }
                                                {row.Validated === 2 &&
                                                    <Clear />
                                                } */}
                                                </ListItemIcon>

                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title="Edit experiment">
                                                    <IconButton
                                                        aria-label="more"
                                                        aria-controls="long-menu"
                                                        aria-haspopup="true"
                                                        onClick={(event: React.MouseEvent<HTMLButtonElement> | undefined) => {
                                                            if (event)
                                                                setExperimentId(row.experimentId); setDialogOpen(true);
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title="Manage interviews">
                                                    <IconButton
                                                        aria-label="more"
                                                        aria-controls="long-menu"
                                                        aria-haspopup="true"
                                                        onClick={(event: React.MouseEvent<HTMLButtonElement> | undefined) => {
                                                            if (event)
                                                                setExperimentId(row.experimentId); setDialogInterviewOpen(true);
                                                        }}
                                                    >
                                                        <QuestionAnswer />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title="Finalize experiment">
                                                    <IconButton
                                                        aria-label="more"
                                                        aria-controls="long-menu"
                                                        aria-haspopup="true"

                                                        onClick={(event: React.MouseEvent<HTMLButtonElement> | undefined) => {
                                                            if (event)
                                                                setExperimentId(row.experimentId); setDialogValidationOpen(true);
                                                        }}
                                                    >
                                                        <EmojiEvents />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )) : []}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </CardContent>
                <CardActions>
                    <Button onClick={() => { setExperimentId(undefined); setDialogOpen(true); }} startIcon={<Add />} size="small">Add experiment</Button>
                    <Button
                        onClick={() => {
                            setDialogPhaseValidationOpen(true);
                            // queryClient.refetchQueries(['experiments', "b80ace52-8948-4d90-8cae-15ec09754e77"]);
                        }}
                        startIcon={<RateReview />}
                        size="small">
                        Review {props.phase.Name}
                    </Button>
                </CardActions>
            </Card>
        </>
    );

}

interface PhaseProps {
    phase: any;
}